module.exports = __webpack_public_path__ + "img/org_name.edc1eca3.png";